<template>
    <div class="listmain ">
        <h1 class="firTitle">自定义主题</h1>
        <h3 class="sedTitle">通用界面定制</h3>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
     1） 通用大Button样式
              <br>
selector_orion_btn.xml用于设置Button的默认样式、不可点击样式、与点击按压样式。以下xml为示例代码，接入方可以按照界面样式自由进行定制。
          </span>
        </p>
        <highlight-code lang="javascript">
           <span>
&lt;?xml version="1.0" encoding="utf-8"?&gt;
&lt;selector xmlns:android="http://schemas.android.com/apk/res/android"&gt;
    &lt;item android:state_pressed="true"&gt;
        &lt;shape android:shape="rectangle"&gt;
            &lt;solid android:color="@color/main_theme_color_pressed" /&gt;
            &lt;corners android:radius="5dp" /&gt;
        &lt;/shape&gt;
    &lt;/item&gt;
    &lt;item android:state_enabled="false"&gt;
        &lt;shape android:shape="rectangle"&gt;
            &lt;solid android:color="@color/color_btn_disabled" /&gt;
            &lt;corners android:radius="5dp" /&gt;
        &lt;/shape&gt;
    &lt;/item&gt;
    &lt;item&gt;
        &lt;shape android:shape="rectangle"&gt;
            &lt;solid android:color="@color/main_theme_color" /&gt;
            &lt;corners android:radius="5dp" /&gt;
        &lt;/shape&gt;
    &lt;/item&gt;
&lt;/selector&gt;

       </span>
        </highlight-code>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
  2） 正在加载的loading图标<br>
orion_sdk_normal_loading.xml 用于设置通用Loading效果动画图片。以下xml为示例代码，接入方可以按照界面样式自由进行定制。
          </span>
        </p>
        <highlight-code lang="javascript">
           <span>
&lt;?xml version="1.0" encoding="utf-8"?&gt;
&lt;rotate xmlns:android="http://schemas.android.com/apk/res/android"
        android:drawable="@drawable/orion_sdk_loading"
        android:fromDegrees="0.0"
        android:pivotX="50.0%"
        android:pivotY="50.0%"
        android:toDegrees="360.0" /&gt;

       </span>
        </highlight-code>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
 3） Activity的TobBar背景<br>
orion_sdk_activity_top_bar_bg用于设置通用界面TopBar/TitleBar的背景，设置格式为drawable类型。以下xml为示例代码，接入方可以按照界面样式自由进行定制。

          </span>
        </p>
        <highlight-code lang="javascript">
           <span>
&lt;shape xmlns:android="http://schemas.android.com/apk/res/android"&gt;
    &lt;gradient
            android:angle="0"
            android:startColor="#3c73f8"
            android:endColor="#62c8fc"/&gt;
&lt;/shape&gt;


       </span>
        </highlight-code>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
 4） Activity的TobBar返回按钮<br>
orion_sdk_activity_top_bar_back_image用于设置通用界面TopBar/TitleBar上返回按钮的图片样式。以下xml为示例代码，接入方可以按照界面样式自由进行定制。


          </span>
        </p>
        <highlight-code lang="javascript">
           <span>
&lt;selector xmlns:android="http://schemas.android.com/apk/res/android"&gt;
    &lt;item android:drawable="@mipmap/orion_sdk_base_ic_enter_u" android:state_pressed="true"/&gt;
    &lt;item android:drawable="@mipmap/orion_sdk_base_ic_enter_u" android:state_enabled="false"/&gt;
    &lt;item android:drawable="@mipmap/orion_sdk_base_ic_enter_n"/&gt;
&lt;/selector&gt;

       </span>
        </highlight-code>
        <h3 class="sedTitle">指定界面定制</h3>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
   1） *必须设置内容<br>
由于部分关键页面包含产品Logo的原因，这部分内容格式都为图片，接入方必须重新设置。清单如下：
          </span>
        </p>
        <highlight-code lang="javascript">
           <span>
&lt;!--信息流对话icon--&gt;
&lt;item name="orion_sdk_history_app_icon"&gt;@mipmap/demo_app_icon&lt;/item&gt;
&lt;!--SDK的AI指令中的引导页图片--&gt;
&lt;item name="orion_sdk_ai_guide_image"&gt;@drawable/orion_sdk_base_pic_ai_education&lt;/item&gt;
&lt;!--SDK的启动dialog的图片--&gt;
&lt;item name="orion_sdk_dialog_start_image"&gt;@drawable/orion_sdk_base_start_pop_default&lt;/item&gt;
&lt;!--信息流设备使用说明$ 控制 --&gt;
&lt;item name="orion_sdk_history_note_control"&gt;@drawable/orion_sdk_history_pic_box_explain_01&lt;/item&gt;
&lt;!--信息流设备使用说明$ 指示灯 --&gt;
&lt;item name="orion_sdk_history_note_light"&gt;@drawable/orion_sdk_history_pic_box_explain_02&lt;/item&gt;
&lt;!--信息流设备使用说明$ 音量键 --&gt;
&lt;item name="orion_sdk_history_note_sound"&gt;@drawable/orion_sdk_history_pic_box_explain_03&lt;/item&gt;
&lt;!--信息流设备使用说明$ 麦克风 --&gt;
&lt;item name="orion_sdk_history_note_mic"&gt;@drawable/orion_sdk_history_pic_box_explain_04&lt;/item&gt;
&lt;!--AI技能顶部引导banner图片 --&gt;
&lt;item name="orion_sdk_ai_banner"&gt;@drawable/orion_sdk_bg_skill_ai&lt;/item&gt;
&lt;!--纠错引导$ 听错--&gt;
&lt;item name="orion_sdk_history_correct_guide_first"&gt;@drawable/orion_sdk_bg_guide_answer&lt;/item&gt;
&lt;!--纠错引导$ 答错--&gt;
&lt;item name="orion_sdk_history_correct_guide_second"&gt;@drawable/orion_sdk_bg_guide_listen&lt;/item&gt;

       </span>
        </highlight-code>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
  2） 个性定制内容<br>
A. 喜马拉雅、QQ音乐大button<br>
orion_sdk_skill_ximalaya_login_color.xml 用于设置喜马拉雅、QQ音乐大Button的默认与选中样式。以下xml为示例代码，接入方可以按照界面样式自由进行定制。
          </span>
        </p>
        <highlight-code lang="javascript">
           <span>
&lt;?xml version="1.0" encoding="utf-8"?&gt;
&lt;selector xmlns:android="http://schemas.android.com/apk/res/android"&gt;
    &lt;item android:state_selected="true"&gt;
        &lt;shape android:shape="rectangle"&gt;
            &lt;solid android:color="@color/orion_sdk_orange" /&gt;
            &lt;corners android:radius="4dp" /&gt;
        &lt;/shape&gt;
    &lt;/item&gt;
    &lt;item android:state_selected = "false"&gt;
        &lt;shape android:shape="rectangle"&gt;
            &lt;solid android:color="@color/orion_sdk_main_theme_color_select" /&gt;
            &lt;corners android:radius="4dp" /&gt;
        &lt;/shape&gt;
    &lt;/item&gt;
&lt;/selector&gt;

       </span>
        </highlight-code>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
  B. 闹钟页TitleBar添加符号的selector<br>
ic_add_selector.xml 用于设置指示用户添加闹钟的图标，包含默认与按下样式。以下xml为示例代码，接入方可以按照界面样式自由进行定制。
          </span>
        </p>
        <highlight-code lang="javascript">
           <span>
&lt;?xml version="1.0" encoding="utf-8"?&gt;
&lt;selector xmlns:android="http://schemas.android.com/apk/res/android"&gt;
    &lt;item android:drawable="@drawable/ic_add_p" android:state_pressed="true"/&gt;
    &lt;item android:drawable="@drawable/ic_add_n"/&gt;
&lt;/selector&gt;
       </span>
        </highlight-code>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
  C. 信息流大按钮selector<br>
orion_sdk_btn_pay_selector.xml 用于设置信息流里面的大Button的样式，包含默认与按下样式。以下xml为示例代码，接入方可以按照界面样式自由进行定制。
          </span>
        </p>
        <highlight-code lang="javascript">
           <span>
&lt;?xml version="1.0" encoding="utf-8"?&gt;
&lt;selector xmlns:android="http://schemas.android.com/apk/res/android"&gt;
    &lt;item android:state_pressed="true"&gt;
        &lt;shape android:shape="rectangle"&gt;
            &lt;solid android:color="#4cF86442" /&gt;
            &lt;corners android:bottomLeftRadius="4dp" android:bottomRightRadius="4dp"/&gt;
        &lt;/shape&gt;
    &lt;/item&gt;
    &lt;item&gt;
        &lt;shape android:shape="rectangle"&gt;
            &lt;solid android:color="#F86442" /&gt;
            &lt;corners android:bottomLeftRadius="4dp" android:bottomRightRadius="4dp"/&gt;
        &lt;/shape&gt;
    &lt;/item&gt;
&lt;/selector&gt;
       </span>
        </highlight-code>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
 D. 收藏页tab切换颜色<br>
sliding_tab_text_selector.xml 用于设置收藏页Tab在默认、按下与选中的样式。以下xml为示例代码，接入方可以按照界面样式自由进行定制。
          </span>
        </p>
        <highlight-code lang="javascript">
           <span>
&lt;?xml version="1.0" encoding="utf-8"?&gt;
&lt;selector xmlns:android="http://schemas.android.com/apk/res/android"&gt;
    &lt;item android:color="@color/orange" android:state_selected="true"/&gt;
    &lt;item android:color="@color/orange" android:state_pressed="true"/&gt;
    &lt;item android:color="@color/black_90"/&gt;
&lt;/selector&gt;
       </span>
        </highlight-code>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
 E. 收藏页、闹钟页的选择checkbox样式<br>
list_radio_selector.xml用于设置checkbox默认、选中与检查时显示的图标。以下xml为示例代码，接入方可以按照界面样式自由进行定制。
          </span>
        </p>
        <highlight-code lang="javascript">
           <span>
&lt;?xml version="1.0" encoding="utf-8"?&gt;
&lt;selector xmlns:android="http://schemas.android.com/apk/res/android"&gt;
    &lt;item android:drawable="@drawable/ic_trip_mode_selected" android:state_checked="true"/&gt;
    &lt;item android:drawable="@drawable/ic_trip_mode_selected" android:state_selected="true"/&gt;
    &lt;item android:drawable="@drawable/ic_trip_mode_unselected"/&gt;
&lt;/selector&gt;
       </span>
        </highlight-code>
        <h3 class="sedTitle">自定义主题清单</h3>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
    在style.xml中新建&lt;style&gt;，或者在已有style中添加，以下是新建style例如

          </span>
        </p>
        <highlight-code lang="javascript">
           <span>
&lt;style name="orion_sdk_default_theme" parent="Theme.AppCompat.Light.NoActionBar"&gt;

    &lt;!--信息流的start--&gt;
    &lt;!--信息流对话icon--&gt;
        &lt;item name="orion_sdk_history_app_icon"&gt;@drawable/orion_sdk_pic_smiling_face&lt;/item&gt;
    &lt;!--信息流的背景--&gt;
    &lt;item name="orion_sdk_home_bg_color"&gt;@color/orion_sdk_home_default_bg_color&lt;/item&gt;
    &lt;!--请求泡泡背景--&gt;
    &lt;item name="orion_sdk_home_request_bg"&gt;@drawable/orion_sdk_list_request_selector&lt;/item&gt;
    &lt;!--请求声音动态图标--&gt;
    &lt;item name="orion_sdk_home_request_voice_speaking"&gt;@drawable/orion_sdk_list_voic_speaking&lt;/item&gt;
    &lt;!--请求声音图标默认静态图标--&gt;
    &lt;item name="orion_sdk_home_request_voice_speaking_static"&gt;@drawable/orion_sdk_ic_home_voice&lt;/item&gt;
    &lt;!--请求文字颜色--&gt;
    &lt;item name="orion_sdk_home_request_text_color"&gt;@color/orion_sdk_home_default_request_text_color&lt;/item&gt;
    &lt;!--请求气泡分割线颜色--&gt;
    &lt;item name="orion_sdk_home_request_divider_color"&gt;@color/orion_sdk_home_default_request_divider_color&lt;/item&gt;
    &lt;!--回应泡泡背景--&gt;
    &lt;item name="orion_sdk_home_response_bg"&gt;@drawable/orion_sdk_home_box_item_selector&lt;/item&gt;
    &lt;!--回应文字颜色--&gt;
    &lt;item name="orion_sdk_home_response_text_color"&gt;@color/orion_sdk_home_default_response_text_color&lt;/item&gt;
    &lt;!--时间泡泡背景--&gt;
    &lt;item name="orion_sdk_home_time_text_bg"&gt;@drawable/orion_sdk_back_time&lt;/item&gt;
    &lt;!--时间文字颜色--&gt;
    &lt;item name="orion_sdk_home_time_text_color"&gt;@color/orion_sdk_dark_black&lt;/item&gt;
    &lt;!--请求反馈文字颜色--&gt;
    &lt;item name="orion_sdk_home_feedback_text_color"&gt;@drawable/orion_sdk_error_mark_text_selector&lt;/item&gt;
    &lt;!--请求反馈图标--&gt;
    &lt;item name="orion_sdk_home_feedback_img"&gt;@drawable/orion_sdk_base_ic_question_mark&lt;/item&gt;
    &lt;!--请求反馈图标(已反馈)--&gt;
    &lt;item name="orion_sdk_home_feedback_img_done"&gt;@drawable/orion_sdk_ic_modify_input_04&lt;/item&gt;
    &lt;!--请求反馈图标(正在编辑)--&gt;
    &lt;item name="orion_sdk_home_feedback_img_editing"&gt;@drawable/orion_sdk_list_correcting&lt;/item&gt;
    &lt;!--回应反馈文字颜色--&gt;
    &lt;item name="orion_sdk_home_response_feedback_text_color"&gt;@drawable/orion_sdk_error_mark_text_selector&lt;/item&gt;
    &lt;!--回应反馈图标--&gt;
    &lt;item name="orion_sdk_home_response_feedback_img"&gt;@drawable/orion_sdk_base_ic_question_mark&lt;/item&gt;
    &lt;!--回应反馈图标(已反馈)--&gt;
    &lt;item name="orion_sdk_home_response_feedback_img_done"&gt;@drawable/orion_sdk_ic_modify_input_04&lt;/item&gt;
    &lt;!--回应反馈图标(正在编辑)--&gt;
    &lt;item name="orion_sdk_home_response_feedback_img_editing"&gt;@drawable/orion_sdk_list_correcting&lt;/item&gt;
    &lt;!--信息流教育图片--&gt;
    &lt;item name="orion_sdk_history_hi_image_src"&gt;@drawable/orion_sdk_pic_history_hi_sample&lt;/item&gt;
    &lt;!--信息流教育button背景--&gt;
    &lt;item name="orion_sdk_history_hi_image_button_background"&gt;@drawable/orion_sdk_xiaoya_hi_btn&lt;/item&gt;

    &lt;!--卡片技能角标文字颜色--&gt;
    &lt;item name="orion_sdk_history_skill_text_color"&gt;@color/orion_sdk_black_50&lt;/item&gt;
    &lt;!--信息流的finish--&gt;

    &lt;!--状态条颜色 start--&gt;
    &lt;!--wifi文字颜色--&gt;
    &lt;item name="orion_sdk_list_info_wifi_text_color"&gt;@color/orion_sdk_text_color_list_info_wifi&lt;/item&gt;
    &lt;!--wifi背景颜色--&gt;
    &lt;item name="orion_sdk_list_info_wifi_background_color"&gt;@color/orion_sdk_background_color_list_info_wifi&lt;/item&gt;

    &lt;!--mic文字颜色--&gt;
    &lt;item name="orion_sdk_list_info_mic_text_color"&gt;@color/orion_sdk_text_color_list_info_mic&lt;/item&gt;
    &lt;!--mic背景颜色--&gt;
    &lt;item name="orion_sdk_list_info_mic_background_color"&gt;@color/orion_sdk_background_color_list_info_mic&lt;/item&gt;

    &lt;!--bluetooth文字颜色--&gt;
    &lt;item name="orion_sdk_list_info_bluetooth_text_color"&gt;@color/orion_sdk_text_color_list_info_bluetooth&lt;/item&gt;
    &lt;!--bluetooth背景颜色--&gt;
    &lt;item name="orion_sdk_list_info_bluetooth_background_color"&gt;@color/orion_sdk_background_color_list_info_bluetooth&lt;/item&gt;
    &lt;!--状态条颜色 end--&gt;

    &lt;!--音乐负反馈start--&gt;
    &lt;!--按钮背景--&gt;
    &lt;item name="orion_sdk_music_feedback_button_background"&gt;@drawable/orion_sdk_btn_border_red_material&lt;/item&gt;
    &lt;!--按钮文字颜色--&gt;
    &lt;item name="orion_sdk_music_feedback_button_text_color"&gt;@color/white&lt;/item&gt;
    &lt;!--个数文字颜色--&gt;
    &lt;item name="orion_sdk_music_feedback_select_size_text_color"&gt;@color/orion_sdk_main_theme_color&lt;/item&gt;
    &lt;!--反馈条目文字默认颜色--&gt;
    &lt;item name="orion_sdk_music_feedback_select_text_text_color"&gt;@color/orion_sdk_black_70&lt;/item&gt;
    &lt;!--反馈条目文字选中颜色--&gt;
    &lt;item name="orion_sdk_music_feedback_select_text_text_color_selected"&gt;@color/orion_sdk_main_theme_color&lt;/item&gt;
    &lt;!--反馈条目默认背景--&gt;
    &lt;item name="orion_sdk_music_feedback_select_text_background"&gt;@drawable/orion_sdk_history_btn_black_thirty&lt;/item&gt;
    &lt;!--反馈条目选中背景--&gt;
    &lt;item name="orion_sdk_music_feedback_select_text_background_selected"&gt;@drawable/orion_sdk_history_orange_stroke_thin&lt;/item&gt;
    &lt;!--音乐负反馈end--&gt;

    &lt;!--信息流设备使用说明$ 控制 --&gt;
    &lt;item name="orion_sdk_history_note_control"&gt;@drawable/orion_sdk_pic_box_unusual&lt;/item&gt;
    &lt;!--信息流设备使用说明$ 指示灯 --&gt;
    &lt;item name="orion_sdk_history_note_light"&gt;@drawable/orion_sdk_pic_box_unusual&lt;/item&gt;
    &lt;!--信息流设备使用说明$ 音量键 --&gt;
    &lt;item name="orion_sdk_history_note_sound"&gt;@drawable/orion_sdk_pic_box_unusual&lt;/item&gt;
    &lt;!--信息流设备使用说明$ 麦克风 --&gt;
    &lt;item name="orion_sdk_history_note_mic"&gt;@drawable/orion_sdk_pic_box_unusual&lt;/item&gt;

    &lt;!--纠错引导$ 听错--&gt;
    &lt;item name="orion_sdk_history_correct_guide_first"&gt;@drawable/orion_sdk_pic_box_unusual&lt;/item&gt;
    &lt;!--纠错引导$ 答错--&gt;
    &lt;item name="orion_sdk_history_correct_guide_second"&gt;@drawable/orion_sdk_pic_box_unusual&lt;/item&gt;

    &lt;!--技能列表start--&gt;
    &lt;!--技能列表页背景--&gt;
    &lt;item name="orion_sdk_skill_bg_color"&gt;@color/orion_sdk_home_default_bg_color&lt;/item&gt;
    &lt;!--技能列表组条背景--&gt;
    &lt;item name="orion_sdk_skill_group_item_bg"&gt;@color/orion_sdk_skill_group_item_bg_color&lt;/item&gt;
    &lt;!--技能列表组条文字颜色--&gt;
    &lt;item name="orion_sdk_skill_group_item_text_color"&gt;@color/orion_sdk_black&lt;/item&gt;
    &lt;!--技能列表子条背景--&gt;
    &lt;item name="orion_sdk_skill_child_item_bg"&gt;@drawable/orion_sdk_white_selector&lt;/item&gt;
    &lt;!--技能列表子条标题文字颜色--&gt;
    &lt;item name="orion_sdk_skill_child_item_title_color"&gt;@color/orion_sdk_black&lt;/item&gt;
    &lt;!--技能列表子条副标题文字颜色--&gt;
    &lt;item name="orion_sdk_skill_child_item_summary_color"&gt;@color/orion_sdk_text_gray&lt;/item&gt;
    &lt;!--技能列表分割线颜色--&gt;
    &lt;item name="orion_sdk_skill_divider_color"&gt;@color/orion_sdk_divider_line&lt;/item&gt;
    &lt;!--技能列表finish--&gt;

    &lt;!--技能列表（带样式）顶部字体颜色（区分选中/未选中）--&gt;
    &lt;item name="orion_sdk_skill_list_text_color"&gt;@drawable/orion_sdk_selector_text_color_black_to_gray&lt;/item&gt;
    &lt;!--技能列表（带样式）顶部指示器颜色--&gt;
    &lt;item name="orion_sdk_skill_list_indicator_color"&gt;@color/main_theme_color&lt;/item&gt;


    &lt;!--技能详情start--&gt;
    &lt;!--技能详情页背景--&gt;
    &lt;item name="orion_sdk_skill_detail_bg_color"&gt;@color/orion_sdk_white&lt;/item&gt;
    &lt;!--技能详情页标题文字颜色--&gt;
    &lt;item name="orion_sdk_skill_detail_title_text_color"&gt;@color/orion_sdk_dark_black&lt;/item&gt;
    &lt;!--技能详情页名字文字颜色--&gt;
    &lt;item name="orion_sdk_skill_detail_name_text_color"&gt;@color/orion_sdk_black_90&lt;/item&gt;
    &lt;!--技能详情页公司文字颜色--&gt;
    &lt;item name="orion_sdk_skill_detail_company_color"&gt;@color/orion_sdk_black_50&lt;/item&gt;
    &lt;!--技能详情页类型文字颜色--&gt;
    &lt;item name="orion_sdk_skill_detail_type_text_color"&gt;@color/orion_sdk_black_30&lt;/item&gt;
    &lt;!--技能详情页描述文字颜色--&gt;
    &lt;item name="orion_sdk_skill_detail_summary_text_color"&gt;@color/orion_sdk_black&lt;/item&gt;
    &lt;!--技能详情页小卡片文字颜色--&gt;
    &lt;item name="orion_sdk_skill_detail_card_text_color"&gt;@color/orion_sdk_black_70&lt;/item&gt;
    &lt;!--技能详情页小卡片背景--&gt;
    &lt;item name="orion_sdk_skill_detail_card_text_bg"&gt;@drawable/orion_sdk_pic_bubble&lt;/item&gt;
    &lt;!--技能详情页小话筒文字颜色--&gt;
    &lt;item name="orion_sdk_skill_detail_mic_text_color"&gt;@color/orion_sdk_black_70&lt;/item&gt;

    &lt;!--技能详情页顶部右边text的颜色--&gt;
    &lt;item name="orion_sdk_skill_detail_title_right_text_color"&gt;@color/orion_sdk_orange&lt;/item&gt;
    &lt;!--技能详情页找手机部分修改密码成功图片--&gt;
    &lt;item name="orion_sdk_skill_find_phone_change_success_image"&gt;@drawable/orion_sdk_base_pic_success&lt;/item&gt;

    &lt;!--技能详情页口令List右上角中"更多"的字体颜色--&gt;
    &lt;item name="orion_sdk_skill_detail_say_more_color"&gt;@color/orion_sdk_say_bed_save_button_color&lt;/item&gt;
    &lt;!--技能详情页口令ExpandTextView中"更多"的字体颜色--&gt;
    &lt;item name="orion_sdk_skill_detail_expand_more_color"&gt;@color/orion_sdk_say_bed_save_button_color&lt;/item&gt;

    &lt;!--技能详情页口令List左上角中文字左边的图片--&gt;
    &lt;item name="orion_sdk_skill_detail_say_text_drawable_left"&gt;@null&lt;/item&gt;
    &lt;!--技能详情页口令List左上角中文字右边的图片--&gt;
    &lt;item name="orion_sdk_skill_detail_say_text_drawable_right"&gt;@drawable/orion_sdk_ic_speak_black&lt;/item&gt;


    &lt;!--技能详情页喜马拉雅登录背景--&gt;
    &lt;item name="orion_sdk_skill_ximalaya_login_color"&gt;@drawable/orion_sdk_btn_skill_detail_manager_selector&lt;/item&gt;
    &lt;!--技能详情页(喜马拉雅、QQ音乐)退出账号背景--&gt;
    &lt;item name="orion_sdk_skill_ximalaya_logout_color"&gt;@color/orion_sdk_main_theme_color_select&lt;/item&gt;
    &lt;!--技能详情finish--&gt;


    &lt;!--情商详情界面group背景--&gt;
    &lt;item name="orion_sdk_skill_eq_group_item_bg"&gt;@color/orion_sdk_white&lt;/item&gt;
    &lt;!--情商详情界面group的标题flag颜色--&gt;
    &lt;item name="orion_sdk_skill_eq_group_item_title_flag_color"&gt;@color/orion_sdk_main_theme_color&lt;/item&gt;
    &lt;!--情商详情界面group的标题的颜色--&gt;
    &lt;item name="orion_sdk_skill_eq_group_item_title_color"&gt;@color/orion_sdk_color_count&lt;/item&gt;
    &lt;!--情商详情界面group右侧向上箭头--&gt;
    &lt;item name="orion_sdk_skill_eq_group_item_right_pack_up"&gt;@drawable/orion_sdk_eq_ic_pack_up&lt;/item&gt;
    &lt;!--情商详情界面group右侧向下箭头--&gt;
    &lt;item name="orion_sdk_skill_eq_group_item_right_pack_down"&gt;@drawable/orion_sdk_ic_drop_down&lt;/item&gt;
    &lt;!--情商详情界面child背景--&gt;
    &lt;item name="orion_sdk_skill_eq_child_item_bg"&gt;@color/orion_sdk_skill_eq_detail_item_background&lt;/item&gt;
    &lt;!--情商详情界面child的标题flag颜色--&gt;
    &lt;item name="orion_sdk_skill_eq_child_item_title_flag_color"&gt;@drawable/orion_sdk_circle_bg&lt;/item&gt;
    &lt;!--情商详情界面child的标题颜色--&gt;
    &lt;item name="orion_sdk_skill_eq_child_item_title_color"&gt;@color/orion_sdk_color_count&lt;/item&gt;
    &lt;!--情商详情界面child的时长标志图片--&gt;
    &lt;item name="orion_sdk_skill_eq_child_item_time_flag_drawable"&gt;@drawable/orion_sdk_ic_duration&lt;/item&gt;
    &lt;!--情商详情界面child的时长颜色--&gt;
    &lt;item name="orion_sdk_skill_eq_child_item_time_color"&gt;@color/orion_sdk_skill_eq_detail_item_time&lt;/item&gt;
    &lt;!--情商详情界面child的状态字体颜色--&gt;
    &lt;item name="orion_sdk_skill_eq_child_item_play_status_color"&gt;@color/orion_sdk_skill_eq_detail_item_kou&lt;/item&gt;
    &lt;!--情商详情界面child的正在进行状态字体颜色--&gt;
    &lt;item name="orion_sdk_skill_eq_child_item_play_status_color_now"&gt;@color/orion_sdk_orange&lt;/item&gt;
    &lt;!--情商详情界面child的title正在进行状态字体颜色--&gt;
    &lt;item name="orion_sdk_skill_eq_child_item_play_status_title_color_now"&gt;@color/orion_sdk_orange&lt;/item&gt;
    &lt;!--情商详情界面child的状态字体背景颜色--&gt;
    &lt;item name="orion_sdk_skill_eq_child_item_play_status_color_bg"&gt;@drawable/orion_sdk_corners_button_blue_bg&lt;/item&gt;
    &lt;!--情商详情界面child的正在进行状态字体背景颜色--&gt;
    &lt;item name="orion_sdk_skill_eq_child_item_play_status_color_now_bg"&gt;@drawable/orion_sdk_corners_button_bg&lt;/item&gt;
    &lt;!--情商详情界面child的状态背景颜色--&gt;
    &lt;item name="orion_sdk_skill_eq_child_item_play_status_bg"&gt;@drawable/orion_sdk_corners_button_bg&lt;/item&gt;
    &lt;!--情商详情界面child的课程使用口令背景状态--&gt;
    &lt;item name="orion_sdk_skill_eq_child_item_word_bg"&gt;@drawable/orion_sdk_bg_education_card&lt;/item&gt;
    &lt;!--课程使用口令的图片--&gt;
    &lt;item name="orion_sdk_skill_eq_child_item_word_image"&gt;@drawable/orion_sdk_base_pic_course_password&lt;/item&gt;
    &lt;!--课程使用的口令--&gt;
    &lt;item name="orion_sdk_skill_eq_child_item_word_title_color"&gt;@color/orion_sdk_skill_eq_detail_item_kou&lt;/item&gt;
    &lt;!--情商详情页面背景--&gt;
    &lt;item name="orion_sdk_skill_eq_detail_bg"&gt;@color/orion_sdk_white&lt;/item&gt;
    &lt;!--情商详情页面header背景--&gt;
    &lt;item name="orion_sdk_skill_eq_detail_header_bg"&gt;@color/orion_sdk_white&lt;/item&gt;
    &lt;!--情商详情页面header标题颜色--&gt;
    &lt;item name="orion_sdk_skill_eq_detail_header_title_color"&gt;@color/orion_sdk_black&lt;/item&gt;
    &lt;!--情商详情页面banner标题颜色--&gt;
    &lt;item name="orion_sdk_skill_eq_detail_banner_title_color"&gt;@color/orion_sdk_white&lt;/item&gt;
    &lt;!--情商详情页面分类标题未选择时的颜色--&gt;
    &lt;item name="orion_sdk_skill_eq_detail_profile_unselect_title_color"&gt;@color/orion_sdk_black_90&lt;/item&gt;
    &lt;!--情商详情页面分类标题选择时的颜色--&gt;
    &lt;item name="orion_sdk_skill_eq_detail_profile_select_title_color"&gt;@color/orion_sdk_main_theme_color&lt;/item&gt;
    &lt;!--情商详情页面分类标题下方View的颜色--&gt;
    &lt;item name="orion_sdk_skill_eq_detail_profile_title_down_color"&gt;@color/orion_sdk_main_theme_color&lt;/item&gt;
    &lt;!--情商弹窗¥与金额的颜色--&gt;
    &lt;item name="orion_sdk_skill_eq_dialog_money_color"&gt;@color/orion_sdk_orange&lt;/item&gt;
    &lt;!--情商弹窗Logo图片--&gt;
    &lt;item name="orion_sdk_skill_eq_dialog_logo_image"&gt;@drawable/orion_sdk_ic_payment_dialog&lt;/item&gt;


    &lt;!--没有网络时的展示图片--&gt;
    &lt;item name="orion_sdk_no_net_drawable"&gt;@drawable/orion_sdk_base_img_no_network&lt;/item&gt;
    &lt;!--收藏无内容的默认图片--&gt;
    &lt;item name="orion_sdk_collect_empty_image"&gt;@drawable/orion_sdk_base_img_no_content&lt;/item&gt;

    &lt;!--闹钟无内容的默认图片--&gt;
    &lt;item name="orion_sdk_alarm_empty_image"&gt;@drawable/orion_sdk_pic_box_unusual&lt;/item&gt;
    &lt;!--快递无内容的默认图片--&gt;
    &lt;item name="orion_sdk_expost_empty_image"&gt;@drawable/orion_sdk_base_img_no_content&lt;/item&gt;

    &lt;!--闹钟页TitleBar添加符号的selector--&gt;
    &lt;item name="orion_sdk_alarm_top_add_selector_drawable"&gt;@drawable/orion_sdk_ic_add_selector&lt;/item&gt;
    &lt;!--闹钟页content字体颜色--&gt;
    &lt;item name="orion_sdk_alarm_content_text_color"&gt;@drawable/orion_sdk_pic_box_unusual&lt;/item&gt;
    &lt;!--闹钟页content边框颜色--&gt;
    &lt;item name="orion_sdk_alarm_content_frame_color"&gt;@drawable/orion_sdk_pic_box_unusual&lt;/item&gt;
    &lt;!--编辑页右上角文字颜色--&gt;
    &lt;item name="orion_sdk_alarm_top_right_btn_text_color_selector"&gt;@color/orion_sdk_color_alarm_top_right_btn_text_selector&lt;/item&gt;
    &lt;!--闹钟流布局view背景selector--&gt;
    &lt;item name="orion_sdk_flow_view_border_selector_drawable"&gt;@drawable/orion_sdk_flow_view_border_bg_selector&lt;/item&gt;
    &lt;!--闹钟流布局view文字颜色selector--&gt;
    &lt;item name="orion_sdk_flow_view_text_color_selector"&gt;@color/orion_sdk_text_color_flow_view_selector&lt;/item&gt;
    &lt;!--闹钟页item分割线颜色--&gt;
    &lt;item name="orion_sdk_divider_color_alarm_item"&gt;@color/orion_sdk_color_alarm_item_divider&lt;/item&gt;

    &lt;!--闹钟列表页面背景颜色--&gt;
    &lt;item name="orion_sdk_bg_color_alarm_list_page"&gt;@color/orion_sdk_white&lt;/item&gt;
    &lt;!--闹钟编辑页时间控件背景颜色--&gt;
    &lt;item name="orion_sdk_bg_color_alarm_edit_picktimeview"&gt;@color/orion_sdk_white&lt;/item&gt;
    &lt;!--闹钟item标题文字颜色--&gt;
    &lt;item name="orion_sdk_text_color_alarm_item_title"&gt;@color/orion_sdk_black_90&lt;/item&gt;
    &lt;!--闹钟item副标题文字颜色--&gt;
    &lt;item name="orion_sdk_text_color_alarm_item_subtitle"&gt;@color/orion_sdk_black_50&lt;/item&gt;
    &lt;!--闹钟item内容（右边文字）文字颜色--&gt;
    &lt;item name="orion_sdk_text_color_alarm_item_content"&gt;@color/orion_sdk_black_50&lt;/item&gt;
    &lt;!--闹钟自定义编辑页icon是否显示--&gt;
    &lt;item name="orion_sdk_alarm_edit_item_icon_visibility"&gt;@bool/orion_sdk_alarm_edit_item_icon_visible&lt;/item&gt;

    &lt;!--圆角弹框negative字体颜色--&gt;
    &lt;item name="orion_sdk_round_angle_dialog_text_color"&gt;@color/text_color_blue&lt;/item&gt;

    &lt;!--自定义子页高亮字体/边框颜色--&gt;
    &lt;item name="orion_sdk_custom_indicator_color"&gt;@color/orion_sdk_orange&lt;/item&gt;
    &lt;!--自定义子页高亮边框背景的Selector--&gt;
    &lt;item name="orion_sdk_custom_border_selector_drawable"&gt;@drawable/orion_sdk_bg_text_round_selector
    &lt;/item&gt;
    &lt;!--自定义子页高亮边框内字体颜色的Selector--&gt;
    &lt;item name="orion_sdk_custom_text_selector_drawable"&gt;@color/text_color_red_white&lt;/item&gt;
    &lt;!--自定义子页选中内容的边框--&gt;
    &lt;item name="orion_sdk_custom_picked_content_border_drawable"&gt;@drawable/orion_sdk_bg_ai_word&lt;/item&gt;
    &lt;!--自定义子页未选中内容的背景--&gt;
    &lt;item name="orion_sdk_custom_picked_content_border_drawable_normal"&gt;@drawable/orion_sdk_shape_edittext_round_bg_normal&lt;/item&gt;


    &lt;!--收藏页tab切换颜色--&gt;
    &lt;item name="orion_sdk_favorite_teb_text_selector"&gt;@drawable/orion_sdk_sliding_tab_text_selector&lt;/item&gt;
    &lt;!--收藏页选中横线颜色--&gt;
    &lt;item name="orion_sdk_favorite_teb_line_color"&gt;@color/orion_sdk_orange&lt;/item&gt;
    &lt;!--收藏页tab背景颜色--&gt;
    &lt;item name="orion_sdk_favorite_teb_bg_color"&gt;@color/orion_sdk_progress_title_bar_color&lt;/item&gt;
    &lt;!--收藏页header （多选、取消）颜色--&gt;
    &lt;item name="orion_sdk_favorite_teb_header_select_color"&gt;@color/orion_sdk_orange&lt;/item&gt;
    &lt;!--收藏页没有内容提示大字颜色--&gt;
    &lt;item name="orion_sdk_favorite_no_content_big_text_color"&gt;@color/orion_sdk_black_50&lt;/item&gt;
    &lt;!--收藏页没有内容提示小字颜色--&gt;
    &lt;item name="orion_sdk_favorite_no_content_prop_color"&gt;@color/orion_sdk_orange&lt;/item&gt;
    &lt;!--收藏节目tab是否隐藏--&gt;
    &lt;item name="orion_sdk_favorite_album_hide"&gt;@bool/orion_sdk_favorite_album_visible&lt;/item&gt;
    &lt;item name="orion_sdk_favorite_choice_view_image_music"&gt;@drawable/orion_sdk_ic_favourite_fm_top&lt;/item&gt;
    &lt;item name="orion_sdk_favorite_choice_view_image_fm"&gt;@drawable/orion_sdk_ic_music_list&lt;/item&gt;
    &lt;item name="orion_sdk_favorite_choice_view_image_children_song"&gt;@drawable/orion_sdk_ic_favourite_fm_top&lt;/item&gt;


    &lt;!--我的声纹没有内容默认图片--&gt;
    &lt;item name="orion_sdk_my_voice_print_add_image"&gt;@drawable/orion_sdk_pic_box_unusual&lt;/item&gt;
    &lt;!--我的声纹列表昵称的颜色--&gt;
    &lt;item name="orion_sdk_my_voice_print_nickname_color"&gt;@color/orion_sdk_black_90&lt;/item&gt;
    &lt;!--我的声纹列表是否开启免密支付的颜色--&gt;
    &lt;item name="orion_sdk_my_voice_print_open_free_pay_color"&gt;@color/orion_sdk_black_50&lt;/item&gt;
    &lt;!--我的声纹跟读页面topbar "取消"颜色--&gt;
    &lt;item name="orion_sdk_my_voice_print_read_top_bar_left_color"&gt;@color/orion_sdk_colorPrimary&lt;/item&gt;
    &lt;!--我的声纹跟读页面读标示颜色--&gt;
    &lt;item name="orion_sdk_my_voice_print_read_flag_color"&gt;@color/orion_sdk_black_50&lt;/item&gt;
    &lt;!--我的声纹跟读页面唤醒内容颜色--&gt;
    &lt;item name="orion_sdk_my_voice_print_read_content_color"&gt;@color/orion_sdk_orange&lt;/item&gt;
    &lt;!--我的声纹跟读页面正在跟读gif图片--&gt;
    &lt;item name="orion_sdk_my_voice_print_reading_gif_drawable"&gt;@drawable/orion_sdk_my_voice_print_xiaobao_box_img&lt;/item&gt;
    &lt;!--我的声纹跟读页面跟读完成gif图片--&gt;
    &lt;item name="orion_sdk_my_voice_print_read_end_gif_drawable"&gt;@drawable/orion_sdk_my_voice_print_xiaobao_box_img&lt;/item&gt;


    &lt;!--我的声纹成功页面topbar "以后"颜色--&gt;
    &lt;item name="orion_sdk_my_voice_print_success_top_bar_right_color"&gt;@color/orion_sdk_colorPrimary&lt;/item&gt;
    &lt;!--我的声纹删除页面topbar "删除"颜色--&gt;
    &lt;item name="orion_sdk_my_voice_print_delete_top_bar_right_color"&gt;@color/orion_sdk_orange&lt;/item&gt;
    &lt;!--我的声纹成功页面成功图片--&gt;
    &lt;item name="orion_sdk_my_voice_print_success_flag_drawable"&gt;@drawable/orion_sdk_my_voice_success_voiceprint&lt;/item&gt;
    &lt;!--我的声纹成功页面失败的图片--&gt;
    &lt;item name="orion_sdk_my_voice_print_error_flag_drawable"&gt;@drawable/orion_sdk_my_voice_fail_voiceprint&lt;/item&gt;
    &lt;!--我的声纹成功页面成功文字描述颜色--&gt;
    &lt;item name="orion_sdk_my_voice_print_success_content_color"&gt;@color/orion_sdk_black_90&lt;/item&gt;
    &lt;!--我的声纹成功页面播放图片--&gt;
    &lt;item name="orion_sdk_my_voice_print_success_play_drawable"&gt;@drawable/orion_sdk_my_voice_print_video_bg_texture_video&lt;/item&gt;
    &lt;!--我的声纹成功页面验证图片--&gt;
    &lt;item name="orion_sdk_my_voice_print_success_verification_drawable"&gt;@drawable/orion_sdk_my_voice_print_video_bg_texture_video&lt;/item&gt;
    &lt;!--我的声纹成功页面同意协议checkbox图片--&gt;
    &lt;item name="orion_sdk_my_voice_print_success_checkbox_drawable"&gt;@drawable/orion_sdk_voice_wei_pay_agreement_checkbox&lt;/item&gt;
    &lt;!--我的声纹成功页面同意协议颜色--&gt;
    &lt;item name="orion_sdk_my_voice_print_success_checkbox_content_color"&gt;@color/orion_sdk_black_50&lt;/item&gt;
    &lt;!--我的声纹协议确定按钮背景--&gt;
    &lt;item name="orion_sdk_my_voice_print_agreement_ok_drawable"&gt;@drawable/orion_sdk_btn_pay_selector&lt;/item&gt;
    &lt;!--我的声纹协议确定按钮字体颜色--&gt;
    &lt;item name="orion_sdk_my_voice_print_agreement_ok_color"&gt;@color/white&lt;/item&gt;
    &lt;!--我的声纹删除页面checkbox图片--&gt;
    &lt;item name="orion_sdk_my_voice_print_delete_checkbox_drawable"&gt;@drawable/orion_sdk_voice_delete_checkbox&lt;/item&gt;
    &lt;!--我的声纹跟读页面第一步的图片--&gt;
    &lt;item name="orion_sdk_my_voice_print_reading_status_drawable_one"&gt;@drawable/orion_sdk_voice_print_ic_pagination_01&lt;/item&gt;
    &lt;!--我的声纹跟读页面第二步的图片--&gt;
    &lt;item name="orion_sdk_my_voice_print_reading_status_drawable_two"&gt;@drawable/orion_sdk_voice_print_ic_pagination_02&lt;/item&gt;
    &lt;!--我的声纹跟读页面第三步的图片--&gt;
    &lt;item name="orion_sdk_my_voice_print_reading_status_drawable_three"&gt;@drawable/orion_sdk_voice_print_ic_pagination_03&lt;/item&gt;
    &lt;!--我的声纹跟读页面第四步的图片--&gt;
    &lt;item name="orion_sdk_my_voice_print_reading_status_drawable_four"&gt;@drawable/orion_sdk_voice_print_ic_pagination_04&lt;/item&gt;
    &lt;!--我的声纹跟读页面第五步的图片--&gt;
    &lt;item name="orion_sdk_my_voice_print_reading_status_drawable_five"&gt;@drawable/orion_sdk_voice_print_ic_pagination_05&lt;/item&gt;



    &lt;!--SDK的主色调--&gt;
    &lt;item name="orion_sdk_main_color"&gt;@color/orion_sdk_colorPrimary&lt;/item&gt;
    &lt;!--SDK中Btn的selector--&gt;
    &lt;item name="orion_sdk_btn_selector_drawable"&gt;@drawable/orion_sdk_selector_orion_btn&lt;/item&gt;
    &lt;!--信息流大按钮selector--&gt;
    &lt;item name="orion_sdk_history_btn_selector"&gt;@drawable/orion_sdk_btn_pay_selector&lt;/item&gt;
    &lt;!--SDK的通用的Activity中TopBar的背景--&gt;
    &lt;item name="orion_sdk_activity_top_bar_bg"&gt;@drawable/orion_sdk_title_bar_color&lt;/item&gt;
    &lt;!--SDK的通用的正在加载的loading图标--&gt;
    &lt;item name="orion_sdk_loading_image"&gt;@drawable/orion_sdk_normal_loading&lt;/item&gt;

    &lt;!--SDK的通用的tabBar的返回图标--&gt;
    &lt;item name="orion_sdk_activity_top_bar_back_image"&gt;@drawable/orion_sdk_back_selector&lt;/item&gt;
    &lt;!--SDK的通用的tabBar的title颜色--&gt;
    &lt;item name="orion_sdk_activity_top_bar_title_color"&gt;@color/orion_sdk_black&lt;/item&gt;
    &lt;!--SDK的通用的tabBar的右边text颜色--&gt;
    &lt;item name="orion_sdk_activity_top_bar_right_color"&gt;@color/orion_sdk_black&lt;/item&gt;
    &lt;!--SDK的通用的check_box图片--&gt;
    &lt;item name="orion_sdk_check_box_drawable"&gt;@drawable/orion_sdk_list_radio_selector&lt;/item&gt;

    &lt;!--SDK的AI指令中的引导页图片--&gt;
    &lt;item name="orion_sdk_ai_guide_image"&gt;@drawable/orion_sdk_pic_box_unusual&lt;/item&gt;
    &lt;!--SDK的启动dialog的图片--&gt;
    &lt;item name="orion_sdk_dialog_start_image"&gt;@drawable/orion_sdk_pic_box_unusual&lt;/item&gt;


    &lt;!--AI口令市场已领取样式图片--&gt;
    &lt;item name="orion_sdk_icon_command_market_collect"&gt;@drawable/orion_sdk_icon_command_market_collect&lt;/item&gt;
    &lt;!--AI口令示例样式图片--&gt;
    &lt;item name="orion_sdk_command_pic_sample"&gt;@drawable/orion_sdk_command_pic_sample_blue&lt;/item&gt;

    &lt;!--微信支付页面tab bar 字体--&gt;
    &lt;item name="orion_sdk_wechat_tab_bar_right_text"&gt;@string/orion_sdk_normal_end&lt;/item&gt;
       </span>
        </highlight-code>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
 上述清单都是SDK中的默认主题，接入方如果有更多想定制的内容可以根据清单中的注释查找指定页面并进行对应的配置。<br>
举例现在想更换信息流的背景则只要在colors.xml中申明新的颜色<br>
1.在colors.xml中声明新的颜色<br>
          </span>
        </p>
        <highlight-code lang="javascript">
           <span>
`&lt;color name="custom_card_bg_color"&gt;#ffff0000&lt;/color&gt;`
           </span>
        </highlight-code>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
 2.在style中更换
          </span>
        </p>
        <highlight-code lang="javascript">
           <span>
`&lt;item name="orion_sdk_home_bg_color"&gt;@color/custom_card_bg_color &lt;/item&gt;`
           </span>
        </highlight-code>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
举例现在想更换信息流回应泡泡的背景则只要替换新的png即可<br>
在drawable中添加新的图片custom_response_bg.png<br>
1.在style中更换
          </span>
        </p>
        <highlight-code lang="javascript">
           <span>
`&lt;item name="orion_sdk_home_response_bg"&gt;@drawable/custom_response_bg&lt;/item&gt;`
           </span>
        </highlight-code>
        <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
在Application中注册theme并调用我们提供的ContainFragmentActivity或BaseFragment（推荐），或在接入控件的Activity申明中用此style即可。
          </span>
        </p>
    </div>
</template>

<script>
    export default {
        name: ""
    };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    h1,
    h2,
    h3,
    h4,
    h5 {
        padding: 0;
        margin: 0px;
        font-weight: normal;
    }

    ul,
    li {
        list-style: none;
    }

    .listmain {
        font-size: 14px;
        line-height: 26px;
        .firTitle {
            font-size: 20px;
            color: #1e4d79;
            margin-bottom: 30px;
        }
        .sedTitle {
            font-size: 16px;
            font-weight: bold;
            padding-bottom: 10px;
            border-bottom: 1px solid #f3f3f3;
            margin-bottom: 15px;
            margin-top: 50px;
            &.fir {
                margin-top: 0px;
            }
        }
        .thirdTitle {
            margin-top: 50px;
            font-weight: bold;
            line-height: 30px;
            font-size: 16px;
        }
        .codeTitle {
            font-weight: bold;
            line-height: 26px;
        }
        pre {
            margin-top: 20px;
        }
        img {
            margin: 30px 0;
            width: 100%;
        }
        table,
        table tr th,
        table tr td {
            border: 1px solid #000;
            text-align: center;
        }
        table {
            line-height: 30px;
            width: 100%;
            border-collapse: collapse;
        }
    }

    .el-submenu .el-menu-item {
        min-width: 190px;
        background: #f5f5f5;
    }

    .el-submenu {
        min-width: 190px;
        background: #f5f5f5;
    }

    img {
        margin-top: 30px;
        margin-bottom: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/tutor/SDK-android/Theme.vue